var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.031 257.174v45.091c0 29.927-24.261 54.177-54.177 54.177h-152.631c-14.268-32.111-23.735-65.592-28.68-99.268z",
    fill: "#73da8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.223 356.443h-113.073c-29.927 0-54.188-24.25-54.188-54.177v-45.091h138.58c4.945 33.676 14.413 67.157 28.681 99.268z",
    fill: "#29ce69"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.709,
    cy: 226.566,
    fill: "#ffcbbe",
    r: 40.939
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.291,
    cy: 226.566,
    fill: "#ffcbbe",
    r: 40.939
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.249 512h-6.531c-66.282-24.219-99.493-63.877-102.235-106.634h83.723c23.838 20.181 40.816 48.212 46.945 80.107 2.647 13.763-7.892 26.527-21.902 26.527z",
    fill: "#f8ea69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.717 512h-223.961c-14.01 0-24.559-12.764-21.912-26.527 6.14-31.895 23.117-59.926 46.956-80.107h96.683c25.362 39.806 59.234 76.223 102.234 106.634z",
    fill: "#f6ca56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.205 405.366c-5.512 23.519-19.986 43.587-39.621 56.413-35.698-16.434-59.437-47.651-55.918-76.306h64.541c11.229 5.254 21.634 11.971 30.998 19.893z",
    fill: "#73da8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.584 461.779c-14.546 9.498-31.915 15.02-50.582 15.02-43.865 0-80.612-30.493-90.203-71.433 9.354-7.922 19.769-14.639 30.998-19.893h53.868c14.918 26.981 33.492 52.663 55.919 76.306z",
    fill: "#29ce69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.599 385.473c-.474 21.675-12.723 40.455-30.596 50.201-25.562-12.048-38.007-30.432-33.337-50.201z",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.003 435.674c-8.314 4.533-17.853 7.108-28 7.108-31.946 0-57.906-25.538-58.607-57.309h53.271c9.58 17.338 20.675 34.13 33.336 50.201z",
    fill: "#ffb39d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.436 226.671c0 93.324-75.45 169.012-168.661 169.434-93.751-94.807-87.989-247.843-25.847-337.013 8.18-1.226 16.555-1.854 25.075-1.854 93.571-.001 169.433 75.861 169.433 169.433z",
    fill: "#ffddcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.775 396.105h-.773c-93.582 0-169.434-75.852-169.434-169.434 0-85.052 62.666-155.475 144.359-167.58-42.227 102.534-37.508 230.833 25.848 337.014z",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.848 135.575c-12.898 13.743-23.627 32.942-31.23 58.913-10.395 3.235-21.036 4.255-32.358 4.255 0-10.93.886-21.654 2.575-32.1 0-.001 23.304-35.757 61.013-31.068z",
    fill: "#5972a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.182 120.068c-25.25 17.596-64.551 36.613-115.535 50.057-9.357-21.632-6.591-47.215 10.549-63.583 35.892-4.029 75.863-.526 104.986 13.526z",
    fill: "#687daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.197 106.541c-5.285 20.635-8.829 41.939-10.549 63.583-19.159 5.061-39.964 9.34-62.293 12.453-2.378.331-4.56-1.447-4.676-3.844-.857-17.612 3.31-36.48 7.889-50.311 15.936-10.95 41.536-18.728 69.629-21.881z",
    fill: "#5972a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.734 198.742c-11.466 0-22.221-1.566-32.358-4.306-7.603-25.95-18.141-44.823-31.06-58.555 42.766.659 60.842 30.802 60.842 30.802 1.701 10.436 2.576 21.14 2.576 32.059z",
    fill: "#687daa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.042,
    cy: 263.525,
    fill: "#ffa1ac",
    rx: 30.241,
    ry: 24.082
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.958,
    cy: 263.525,
    fill: "#ffa1ac",
    rx: 30.241,
    ry: 24.082
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m191.667 247.843c-4.142 0-7.5-3.357-7.5-7.5v-12.361c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v12.361c0 4.142-3.358 7.5-7.5 7.5z",
    fill: "#495560"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m320.334 247.843c-4.142 0-7.5-3.357-7.5-7.5v-12.361c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v12.361c0 4.142-3.358 7.5-7.5 7.5z",
    fill: "#495560"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 255.202c-8.667 0-16.91-3.754-22.615-10.299-2.722-3.122-2.396-7.86.726-10.581 3.122-2.724 7.86-2.398 10.582.726 2.855 3.275 6.977 5.154 11.307 5.154s8.452-1.879 11.307-5.154c2.721-3.123 7.459-3.448 10.582-.726 3.123 2.721 3.448 7.459.726 10.581-5.705 6.545-13.947 10.299-22.615 10.299z",
    fill: "#495560"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m452.159 166.683c-51.561-38.828-129.133-50.17-196.157-50.705-14.515.216-29.082.834-43.535 1.999-10.493-49.69 15.782-101.547 49.964-117.874 95.951 3.049 174.729 74.122 189.728 166.58z",
    fill: "#73da8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.431.103c-23.571 34.892-40.445 75.111-49.964 117.873-55.898 4.533-110.085 17.441-152.632 48.666 15.35-94.498 97.332-166.642 196.167-166.642 2.153 0 4.296.031 6.429.103z",
    fill: "#29ce69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.917 80.052c.475 2.727-1.777 5.171-4.525 4.841-18.913-2.27-38.823-3.488-59.389-3.488-11.476 0-22.746.381-33.749 1.113-4.376-17.688 4.151-39.352 19.357-46.822 1.133-.072 2.266-.113 3.42-.113h21.933c26.529-.001 48.554 19.207 52.953 44.469z",
    fill: "#687daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.611 35.696c-7.541 14.979-14.01 30.638-19.357 46.822-8.714.571-17.279 1.375-25.638 2.377-2.715.325-5.008-2.066-4.543-4.76 4.174-24.205 24.536-42.875 49.538-44.439z",
    fill: "#5972a5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.c3adec4f63f4c621e5f6d994ce6e942d.svg";
export { ForwardRef as ReactComponent };